export function getFileNameFromObjectName(objectName: string): string {
  const segments = objectName.split('/').filter(Boolean);

  return segments[segments.length - 1] ?? objectName;
}
